import { useEffect, useRef } from "react";
import { ReactComponent as ChronometerIcon } from "../../../assets/mix_icons/chronometer.svg";
import clockAlert from '../../../assets/audios/clock_hurry.mp3';
import './Chronometer.css';

const MIN_TIME = 10;

export default function Chronometer({ time }) {
    const clockAlertRef = useRef(false);

    useEffect(() => {
        if (time <= MIN_TIME && !clockAlertRef.current) {
            const audio = new Audio(clockAlert);
            audio.play();
            clockAlertRef.current = true;
        } else if (time > MIN_TIME) {
            clockAlertRef.current = false;
        }
    }, [time]);

    return (
        <div className={`chronometer-container border-2 flex items-center justify-center gap-2 rounded-xl ${time <= MIN_TIME ? 'bg-red shaking-slow border-white' : 'bg-light-green border-dark-blue'}`}>
            <ChronometerIcon height={20} width={20} className="object-fit media-icon-white" />
            <span className={`text-base ${time <= MIN_TIME ? 'pulse-fast' : ''}`}>{time > 0 ? time : 0}</span>
        </div>
    )
}